import { CoroutineDispatcherizb7p9bijexj as CoroutineDispatcher } from './CoroutineDispatcher.mjs';
import { ArrayDeque2dzc9uld4xi7n as ArrayDeque } from '../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayDeque.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  add2suhfggl4zvkk as add,
  subtract2orl8z9upxd9l as subtract,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import {
  checkParallelism305j5epqg3ju0 as checkParallelism,
  namedOrThis1pi8a62t67wtr as namedOrThis,
} from './internal/LimitedDispatcher.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Symbol17xuwzgi5g8ve as Symbol } from './internal/Symbol.mjs';
import { commonThreadLocal18t70xomalc6z as commonThreadLocal } from './internal/ThreadLocal.mjs';
import { createEventLoop3pvigh4qbw0m0 as createEventLoop } from './EventLoop.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function delta($this, unconfined) {
  return unconfined ? 4294967296n : 1n;
}
var EventLoopClass;
function EventLoop() {
  if (EventLoopClass === VOID) {
    class $ extends CoroutineDispatcher() {
      constructor() {
        super();
        this.m13_1 = 0n;
        this.n13_1 = false;
        this.o13_1 = null;
      }
      p13() {
        var tmp0_elvis_lhs = this.o13_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return false;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var queue = tmp;
        var tmp1_elvis_lhs = queue.rj();
        var tmp_0;
        if (tmp1_elvis_lhs == null) {
          return false;
        } else {
          tmp_0 = tmp1_elvis_lhs;
        }
        var task = tmp_0;
        task.q11();
        return true;
      }
      q13(task) {
        var tmp0_elvis_lhs = this.o13_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.also' call
          var this_0 = ArrayDeque().nj();
          this.o13_1 = this_0;
          tmp = this_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var queue = tmp;
        queue.pj(task);
      }
      r13() {
        return this.m13_1 >= delta(this, true);
      }
      s13() {
        var tmp0_safe_receiver = this.o13_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.n1();
        return tmp1_elvis_lhs == null ? true : tmp1_elvis_lhs;
      }
      t13(unconfined) {
        this.m13_1 = add(this.m13_1, delta(this, unconfined));
        if (!unconfined)
          this.n13_1 = true;
      }
      u13(unconfined) {
        this.m13_1 = subtract(this.m13_1, delta(this, unconfined));
        if (this.m13_1 > 0n)
          return Unit_instance;
        // Inline function 'kotlinx.coroutines.assert' call
        if (this.n13_1) {
          this.v13();
        }
      }
      s12(parallelism, name) {
        checkParallelism(parallelism);
        return namedOrThis(this, name);
      }
      v13() {
      }
    }
    initMetadataForClass($, 'EventLoop');
    EventLoopClass = $;
  }
  return EventLoopClass;
}
var ThreadLocalEventLoopClass;
function ThreadLocalEventLoop() {
  if (ThreadLocalEventLoopClass === VOID) {
    class $ {
      constructor() {
        ThreadLocalEventLoop_instance = this;
        this.w13_1 = commonThreadLocal(new (Symbol())('ThreadLocalEventLoop'));
      }
      x13() {
        var tmp0_elvis_lhs = this.w13_1.z13();
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.also' call
          var this_0 = createEventLoop();
          ThreadLocalEventLoop_getInstance().w13_1.a14(this_0);
          tmp = this_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
    }
    initMetadataForObject($, 'ThreadLocalEventLoop');
    ThreadLocalEventLoopClass = $;
  }
  return ThreadLocalEventLoopClass;
}
var ThreadLocalEventLoop_instance;
function ThreadLocalEventLoop_getInstance() {
  if (ThreadLocalEventLoop_instance === VOID)
    new (ThreadLocalEventLoop())();
  return ThreadLocalEventLoop_instance;
}
//region block: exports
export {
  ThreadLocalEventLoop_getInstance as ThreadLocalEventLoop_getInstance3cwmmp6tb23lb,
  EventLoop as EventLoopljivmgnf56lj,
};
//endregion

//# sourceMappingURL=EventLoop.common.mjs.map
